import React from "react";
import { Scrollbars } from "react-custom-scrollbars-2";
import { Card, CardBody } from "@windmill/react-ui";

import Title from "components/form/Title";
import LabelArea from "components/form/LabelArea";

import Error from "components/form/Error";

import DrawerButton from "components/form/DrawerButton";
import useLanguageDriverSubmit from "hooks/useLanguageDriverSubmit";
import InputName from "components/form/InputName";

const LanguageDriverDrawer = ({ id }) => {
  const { trigger, register, handleSubmit, onSubmit, errors } =
    useLanguageDriverSubmit(id);

  const handleFormSubmit = (data) => {
    onSubmit(data);
  };

  return (
    <>
      <div className="w-full relative p-6 border-b border-gray-100 bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-300">
        {id ? (
          <Title register={register} title="Edit language" />
        ) : (
          <Title register={register} title="Add language" />
        )}
      </div>
      <Scrollbars className="w-full md:w-7/12 lg:w-8/12 xl:w-8/12 relative dark:bg-gray-700 dark:text-gray-200">
        <Card className="flex-grow scrollbar-hide w-full max-h-full">
          <CardBody>
            <form onSubmit={handleSubmit(handleFormSubmit)}>
              <div className="px-2 flex-grow scrollbar-hide w-full max-h-full pb-20">
                <div className="grid grid-cols-12 gap-5 mb-6 items-center">
                  <div className="col-span-6">
                    <LabelArea label="Language" required />
                    <InputName
                      trigger={trigger}
                      register={register}
                      label="Language"
                      name="lang_driver"
                      type="text"
                      placeholder="Language"
                      pattern={/^[A-Za-z]+$/}
                    />
                    <Error errorName={errors.lang_driver} />
                  </div>
                </div>
              </div>

              <DrawerButton id={id} title={id ? "Update" : "Submit"} />
            </form>
          </CardBody>
        </Card>
      </Scrollbars>
    </>
  );
};

export default LanguageDriverDrawer;
